module.exports = __webpack_public_path__ + "static/media/intro.850319eb.mp3";